import { render } from "./approvals.vue?vue&type=template&id=c404cd94&scoped=true"
import script from "./approvals.vue?vue&type=script&lang=js"
export * from "./approvals.vue?vue&type=script&lang=js"

import "./approvals.vue?vue&type=style&index=0&id=c404cd94&scoped=true&lang=css"
import "./approvals.vue?vue&type=style&index=1&id=c404cd94&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c404cd94"]])

export default __exports__